import { Row } from "react-bootstrap";
import { Type } from "../actions/types";
import ProductType from "./ProductType";

const TYPE_HOT_SALES = "Hot Sale";

interface Props {
  productTypes: Type[];
}

const ProductTypeList = (props: Props) => {
  const { productTypes } = props;
  const productTypesFiltered = productTypes.filter(
    (item) => !item.name.includes("Talle") && item.name !== TYPE_HOT_SALES
  );
  return (
    <Row xs={1} md={3} lg={4} className="g-1">
      {productTypesFiltered.map((productType, index: number) => (
        <ProductType key={index} productType={productType} />
      ))}
    </Row>
  );
};

export default ProductTypeList;
